<template>
<v-layout row wrap justify-center align-center class="no-gutters">
    <v-flex xs12 sm11 md10 class="mx-auto text-center pa-3">
        <div v-if="!cargoInfo" class="d-flex justify-center align-center" >
            <v-progress-circular
            :width="5"
            size="50"
            color="primary"
            indeterminate
        ></v-progress-circular>
        </div>
        <div class="mx-auto">
          <h2 class="mb-3 titulo-riesgo">RIESGOS</h2>
          <p class="px-2"><b>Conozca el significado de cada una de estas variables haciendo clic sobre cada elemento:</b></p>
        </div>
        <div class="cont-conoce mt-3">
          <div class="cont-g-expand">

            <div class="text-center item-exp-cont pt-1">
              <h2 class="mb-6 mt-2 titulo-item">AMENAZA</h2>
              <div class="cont-img-exp mt-2 hvr" :class="{'bot-check-vis-cen':vistos[0]}" @click="abrirExpand(0)">
                <img src="../assets/img/r-icon-1.png" alt="">
              </div>
              <!-- <v-btn fab x-small class="mx-auto mt-n8" dark color="#F8A834" @click="abrirExpand(0)" >
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn> -->
              <!-- <v-expand-transition>
                <div v-show="verA[0]" class="item-exp-text"> 
                  <p>
                    Es todo evento potencialmente peligroso, de origen natural o provocado por la actividad humana.
                  </p>
                  <p>
                    Por ejemplo, una amenaza puede ser una inundación, un deslizamiento de tierra, una erupción volcánica, un derrame de petróleo. 
                  </p>
                </div>
              </v-expand-transition> -->
            </div>

            <div class="cont-icon-info"> <img src="../assets/img/icon-info-1.png" alt=""> </div>

            <div class="text-center item-exp-cont pt-4">
              <h2 class="mb-6 mt-2 titulo-item">EXPOSICIÓN</h2>
              <div class="cont-img-exp mt-2 hvr" :class="{'bot-check-vis-cen':vistos[1]}" @click="abrirExpand(1)">
                <img src="../assets/img/r-icon-2.png" alt="">
              </div>
              <!-- <v-btn fab x-small class="mx-auto mt-n8" dark color="#015487" @click="abrirExpand(1)">
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn> -->
              <!-- <v-expand-transition>
                <div v-show="verA[1]" class="item-exp-text"> 
                  <p>
                    Corresponde a la presencia de personas, medios de subsistencia, o ecosistemas, recursos ambientales, infraestructura, o activos económicos, sociales o culturales en lugares que podrían verse afectados negativamente por las amenazas climáticas 
                  </p>
                </div>
              </v-expand-transition> -->
            </div>

            <div class="cont-icon-info"> <img src="../assets/img/icon-info-1.png" alt=""> </div>

            <div class="text-center item-exp-cont pt-4">
              <h2 class="mb-6 mt-2 titulo-item">VULNERABILIDAD</h2>
              <div class="cont-img-exp mt-2 hvr" :class="{'bot-check-vis-cen':vistos[2]}" @click="abrirExpand(2)" >
                <img src="../assets/img/r-icon-3.png" alt="">
              </div>
              <!-- <v-btn fab x-small class="mx-auto mt-n8" dark color="#05AD42"  @click="abrirExpand(2)">
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn> -->
              <!-- <v-expand-transition>
                <div v-show="verA[2]" class="item-exp-text"> 
                  <p>
                    Es la predisposición de ser afectado negativamente por la ocurrencia de un evento 
potencialmente peligroso. Este concepto está relacionado con las condiciones sociales y 
económicas de la población, así como con su capacidad de adaptarse a los cambios. 
                  </p>
                  <p>
                    Por ejemplo, son población muy vulnerable: niños, personas de tercera edad, personas con discapacidades, personas con escasos recursos económicos, personas que habitan en condiciones precarias de vivienda, grupos de poblaciones que no cuentan o no conocen los planes de 
evacuación y respuesta de su comunidad, etc. 
                  </p>
                </div>
              </v-expand-transition> -->
            </div>

            <div class="cont-icon-info"> <img src="../assets/img/icon-info-2.png" alt=""> </div>

            <div class="text-center item-exp-cont pt-4">
              <h2 class="mb-6 mt-2 titulo-item">RIESGO</h2>
              <div class="cont-img-exp mt-2 hvr" :class="{'bot-check-vis-cen':vistos[3]}" @click="abrirExpand(3)" >
                <img src="../assets/img/r-icon-4.png" alt="">
              </div>
              <!-- <v-btn fab x-small dark class="mx-auto mt-n8" color="#CD5429"  @click="abrirExpand(3)">
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn> -->
              <!-- <v-expand-transition>
                <div v-show="verA[3]" class="item-exp-text"> 
                <p class="px-2">El riesgo es la probabilidad de ocurrencia de un evento peligroso que pueda causar daños a las personas o pérdidas materiales El riesgo es una combinación de tres variables: amenaza, exposición y vulnerabilidad, Estas tres condiciones deben ocurrir para que exista un riesgo. </p>
                </div>
              </v-expand-transition> -->
            </div>
          
          </div>
        </div>
        <div>
          <div class="cont-titulo-resm">
            <img src="../assets/img/r-icon-5.png" width="100px" alt="RIESGOS CLIMÁTICOS EN LA CIUDAD DE ESMERALDAS">
            <div class="rem-titulo">
              <h2>RIESGOS CLIMÁTICOS EN LA CIUDAD DE ESMERALDAS</h2>
            </div>

          </div>
          <p>
            Los principales riesgos de origen climático en la ciudad de Esmeraldas son las inundaciones y los deslizamientos de tierra, pues gran parte de la población esmeraldeña está asentada sobre las planicies inundables de los ríos Esmeraldas y Teaone, así como también en el colinado occidental de la ciudad, como el cerro Gatazo, Regocijo, entre otros. 
          </p>
          <p>
            Con el cambio climático estos riesgos pueden aumentar debido al incremento de la frecuencia y de la intensidad de las lluvias. 
          </p>
        </div>
    </v-flex>
        <!-- MODAL HISTORIA -->
    <modal-app v-model="modal" :fullscreen="false" :colorBar="colorSelect[posColor]">
      <template slot="modalcontent"> 
        <div v-if="textoModal === 0">
          <div class="text-center animated flipInY ">
            <img src="../assets/img/r-icon-1.png" width="100px" alt="EXPOSICIÓ">
            <h2 class="mb-6 mt-2 titulo-item">AMENAZA</h2>
          </div>
          <p>
            Es todo evento potencialmente peligroso, de origen natural o provocado por la actividad humana.
          </p>
          <p>
            Por ejemplo, una amenaza puede ser una inundación, un deslizamiento de tierra, una erupción volcánica, un derrame de petróleo. 
          </p>
        </div>
        <div v-if="textoModal === 1">
          <div class="text-center animated flipInY ">
            <img src="../assets/img/r-icon-2.png" width="100px" alt="EXPOSICIÓ">
            <h2 class="mb-6 mt-2 titulo-item">EXPOSICIÓN</h2>
          </div>
          <p>
            Corresponde a la presencia de personas, medios de subsistencia, o ecosistemas, recursos ambientales, infraestructura, o activos económicos, sociales o culturales en lugares que podrían verse afectados negativamente por las amenazas climáticas 
          </p>
        </div>
         <div v-if="textoModal === 2">
          <div class="text-center animated flipInY ">
            <img src="../assets/img/r-icon-3.png" width="100px" alt="EXPOSICIÓ">
            <h2 class="mb-6 mt-2 titulo-item">VULNERABILIDAD</h2>
          </div>
          <p>
            Es la predisposición de ser afectado negativamente por la ocurrencia de un evento potencialmente peligroso. Este concepto está relacionado con las condiciones sociales y económicas de la población, así como con su capacidad de adaptarse a los cambios. 
          </p>
          <p>
            Por ejemplo, son población muy vulnerable: niños, personas de tercera edad, personas con discapacidades, personas con escasos recursos económicos, personas que habitan en condiciones precarias de vivienda, grupos de poblaciones que no cuentan o no conocen los planes de evacuación y respuesta de su comunidad, etc. 
          </p>
        </div>
        <div v-if="textoModal === 3">
          <div class="text-center animated flipInY ">
            <img src="../assets/img/r-icon-4.png" width="100px" alt="EXPOSICIÓ">
            <h2 class="mb-6 mt-2 titulo-item">RIESGO</h2>
          </div>
          <p>El riesgo es la probabilidad de ocurrencia de un evento peligroso que pueda causar daños a las personas o pérdidas materiales El riesgo es una combinación de tres variables: amenaza, exposición y vulnerabilidad, Estas tres condiciones deben ocurrir para que exista un riesgo. </p>
        </div>
      </template>
    </modal-app>

</v-layout>
</template>
<script>
import axios from "axios"
export default {
    name:'conoceRiesgos',
    data() {
        return {
          modal:false,
          textoModal:0,
          dataRiesgos:null,
          cargoInfo:false,
          verA:Array(4).fill(false),
          vistos:Array(4).fill(false),
          colorSelect:['#F8A934','#005487','#00AE42','#CE5429'],
          posColor:0
        }
    },
    async mounted() {
        await axios
        .get(''+this.$store.state.rutaApi+'infografia')
        .then(response => (this.dataRiesgos = response.data[0]))
        // console.log('ddd',this.dataRiesgos)
        this.cargoInfo = true
    },
    methods:{
      abrirExpand(val){
        this.modal = true
        this.textoModal = val
        this.posColor = val
        this.$set(this.vistos, val, true)

        // this.verA = Array(4).fill(false)
      //   if(this.verA[val]){
      //     this.$set(this.verA, val, false)
      //   }else{
      //     this.$set(this.verA, val, true)
      //   }
      // }
      },
    }
}
</script>
<style lang="scss" scoped>
.cont-conoce{
  width: 100%;
  text-align: center;
  padding: 10px;
}
.imagen-conoce{
  min-width: 900px;
  width: 100%;
}
.cont-g-expand{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  // flex-flow: row;
}
.item-exp-cont{
  align-self:center;
  // border: solid #8C8C8C 1px;
  border-radius: 10px;
  padding: 10px;
  // min-width: 300px;
  // max-width: 300px;
  height: auto;
  .cont-img-exp{
    margin-bottom: 10px;
    img{
      width: 100px;
    }
  }
  .item-exp-text{
    margin-top: 10px;
    max-width: 300px;
    padding: 10px;
    p{
      // margin: 0px;
      padding: 0px;
    }
  }
  @media screen and (max-width: 700px) {
    width: 100%;
    width: 100%;
  }
}
.cont-icon-info{
  // height: 180px;
  display: flex;
  align-items: center;
  padding: 5px;
  margin-top: 20px;
  img{
    width: 25px;
  }
  @media screen and (max-width: 700px) {
    margin-top: 0px;
  }
}
.titulo-riesgo{
  border-bottom: 1px #005487 solid;
  color: #005487;
  font-size: 2em;
}
.titulo-item{
  // color: #005487;
  font-size: 1.2em;
  line-height: 1em;
}
.cont-titulo-resm{
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0px;

  img{
    margin-right: -120px;
    z-index: 1;
  }
  .rem-titulo{
    padding: 10px;
    border-radius: 10px;
    background: #13A44E;
    padding-left: 140px;
    h2{
      color: white;
      font-size: 1.5em;
      font-weight: 600;
    }
  }
}
</style>